export default (id, section) => {
  $.ajax({
    type: "POST",
    url: "/datapulse/dismiss-errors",
    data: {
      section_id: id,
      section_name: section
    },
  });
};
